module.exports = __webpack_public_path__ + "static/media/Card_icon.fb57d5a3.svg";